import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { boldFont, textSize, color } from '@portal/kit/pkg/styles'
import { withRanIcon, ranIcon, withDesktopRanIcon, desktopRanIcon } from 'styles/helpers'

const dashboardStyles = createUseStyles(theme => ({
  internetAccessText: {
    marginBottom: 12,
    ...withRanIcon(),
    ...textSize(14, 20),
    '&:last-child': {
      marginBottom: 0
    },
    '& strong': {
      ...boldFont()
    }
  },
  internetAccessIcon: {
    ...ranIcon(theme),
    '&.fa-times-circle': {
      ...color('textError'),
    }
  },
  [config.mediaQueries.tabletPortrait]: {
    internetAccessText: {
      ...withDesktopRanIcon(),
    },
    internetAccessIcon: {
      ...desktopRanIcon(),
      fontSize: 20,
    }
  }
}))

export default dashboardStyles
